/* eslint-disable import/no-anonymous-default-export */
import React, { useRef, useState } from 'react';
import { useTheme, Icon, Popover } from '@mui/material';
import { get, size } from 'global/lib/lodash';
import { ActiveWrap, BtnText, Container, OptNumber, RowWrap, ToggleButton, ToggleIcon } from './styles';
import { getColorFromScore } from 'global/styles';
import getDisplayScoreLabel from 'global/utils/getDisplayScore';
import { lighten } from '@mui/material/styles';

export default (props) => {
  const variant = get(props, 'variant', 'normal');
  const options = get(props, 'options', []);
  const scorecardConfig = get(props, 'scorecardConfig');
  const getHighlight = get(props, 'getHighlight', null);
  const { selected } = props;
  const templateUnchanged = get(props, 'templateUnchanged', false);
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRef = useRef();
  const ignoreConfigColor = get(scorecardConfig, 'ignoreColor', true);

  const open = Boolean(anchorEl);

  const btnPress = (e, opt, i) => {
    const onPress = get(props, 'onSelect', () => 0);
    onPress(opt, i);
    setAnchorEl(null);
  };

  const getColorFromValue = (val, isSelected = false, isTemplateUnchanged = false) => {
    const initialColor = getColorFromScore(val, scorecardConfig && !ignoreConfigColor ? [scorecardConfig.minScore || 0, scorecardConfig.maxScore || 100] : undefined);
    // If selected and template_unchanged is true, use half intensity (lightened color)
    const color = isSelected && isTemplateUnchanged ? lighten(initialColor, 0.75) : initialColor;
    return {
      borderColor: color,
      backgroundColor: isSelected ? color : undefined,
      color: isSelected ? theme.palette.getContrastText(color) : undefined,
    };
  };

  const getIconFromIndex = (i) => {
    const icons = ['close', 'check', 'indeterminate_check_box'];
    return icons[i];
  };

  if (size(options) > 6) {
    const currentSel = !(selected >= 0) ? options.find(o => get(o,'value') === selected) : options[selected];
    const buttonTextContentFirst = get(currentSel, 'criteria', '');
    // If currentSel exists, it means there's a selection (either by index or by value)
    const isCurrentSelected = !!currentSel;
    const currentValue = currentSel ? get(currentSel, 'value') : null;

    return (
      <Container variant={variant}>
        <ToggleButton
          ref={buttonRef}
          variant={variant}
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={(e) => setAnchorEl(buttonRef.current)}
          style={getColorFromValue(currentValue, isCurrentSelected, templateUnchanged && isCurrentSelected)}
        >
          <OptNumber>{getDisplayScoreLabel(currentSel, selected, scorecardConfig, true)}</OptNumber>
          <BtnText>{getHighlight ? getHighlight(buttonTextContentFirst) : buttonTextContentFirst}</BtnText>
          <span style={{ marginLeft: 'auto', marginTop: 5 }}>
            <Icon>arrow_drop_down</Icon>
          </span>
        </ToggleButton>

        <Popover
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            horizontal: 0,
            vertical: 0,
          }}
          elevation={0}
        >
          <div style={{ width: get(anchorEl, 'clientWidth', 0) + 5 }}>
            {options.map((opt, i) => {
              const isSelected = opt.index === selected;
              const buttonTextContent = get(opt,'criteria','');
              return (
                <ToggleButton key={i} variant={variant} onClick={(e) => btnPress(e, opt, opt.index)} style={getColorFromValue(opt.value, isSelected, templateUnchanged && isSelected)}>
                  <OptNumber>{getDisplayScoreLabel(opt, i, scorecardConfig, true)}</OptNumber>
                  <BtnText>{getHighlight ? getHighlight(buttonTextContent) : buttonTextContent}</BtnText>
                </ToggleButton>
              );
            })}
          </div>
        </Popover>
      </Container>
    );
  }

  const isDisabled = get(props, 'isDisabled', false);

  return (
    <Container variant={variant} style={isDisabled ? { pointerEvents: 'none' } : {}}>
      {options.map((opt, i) => {
        const isSelected = opt.index === selected;
        const isActiveWrap = props.isActive !== undefined && get(props, 'isActive.value') === opt.index;
        const isCompareWrap = props.isCompare !== undefined && get(props, 'isCompare.value') === opt.index;
        // if it's pass/fail style, prioritize criteria for button text, then label; else use label
        const buttonTextContent = variant === 'passFail' ? (get(opt,'criteria') || get(opt,'label') || getDisplayScoreLabel(opt,i,scorecardConfig,true)) : get(opt,'criteria','');
        const WrapEl = (isActiveWrap || isCompareWrap) ? ActiveWrap : RowWrap;
        return (
          <WrapEl key={i}>
            <ToggleButton variant={variant} onClick={(e) => btnPress(e, opt, opt.index)} style={getColorFromValue(opt.value, isSelected, templateUnchanged && isSelected)}>
              {variant === 'passFail' ? <ToggleIcon>{getIconFromIndex(i)}</ToggleIcon> : <OptNumber>{getDisplayScoreLabel(opt, i, scorecardConfig,true)}</OptNumber>}
              <BtnText>{getHighlight ? getHighlight(buttonTextContent) : buttonTextContent}</BtnText>
            </ToggleButton>
            {(isActiveWrap && isCompareWrap) ? <span className='activetext'>{`your score & ${get(props,'isCompare.text') || 'target'}`}</span>
              : isActiveWrap ? <span className='activetext'>your score</span>
              : isCompareWrap ? <span className='activetext'>{`${get(props,'isCompare.text') || 'target'} score`}</span> : undefined
            }
          </WrapEl>
        );
      })}
    </Container>
  );
};
